module.exports = __webpack_public_path__ + "img/far_day.26b26fcb.jpg";